import { useCallback, useRef } from 'react';
import { voiceEventEffect } from '../../lib/voice-events';
import { ENDED_VOICE_STATE } from './useVoiceState';

export function useVoiceEvents(call, record, update) {
  const generating = useRef(false);
  const receive = useCallback(event => {
    if (record(event)) {
      call.current?.close(); update({ ...ENDED_VOICE_STATE, reason: 'limit' }); return;
    }
    const effect = voiceEventEffect(event);
    if (effect.generating !== undefined) generating.current = effect.generating;
    if (effect.state) update(effect.state);
    if (effect.fatal) call.current?.fail('voice_unavailable');
  }, [call, record, update]);
  return { generating, receive };
}